import type { ReactNode } from 'react';

export const symbol_precision_manufacturing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M213-120q-20 0-33.5-13.5T166-167q0-20 13.5-33.5T213-214h80L187-576q-32-15-50-40.5T119-684q0-47 34.5-81.5T235-800q44 0 73 23.5t39 62.5h146v-59q0-12 9-21t21-9q11 0 18.5 8.5T549-775l75-72q8-8 20.5-10.5T670-854l158 76q9 5 12.5 14t-1.5 19q-5 10-14.5 12t-18.5-3l-155-75-98 99v52l98 103 155-76q10-5 19-2.5t14 12.5q5 10 1.5 20T827-588l-153 72q-14 7-27 6.5T624-520l-75-72q0 14-7.5 21t-18.5 7q-12 0-21-9t-9-21v-60H345q0 12-6.5 24.5T323-609l205 395h111q20 0 33.5 13.5T686-167q0 20-13.5 33.5T639-120H213Zm62-524q16-16 16-40t-16-40q-16-16-40-16t-40 16q-16 16-16 40t16 40q16 16 40 16t40-16Zm84 430h102L272-581q-3 2-10 4t-11 3l108 360Zm102 0Z"
		/>
	</svg>
);
